import { render, staticRenderFns } from "./ReportRentPerformance.vue?vue&type=template&id=527afa10&"
import script from "./ReportRentPerformance.vue?vue&type=script&lang=js&"
export * from "./ReportRentPerformance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports